module.exports = __webpack_public_path__ + "static/media/1343_pediatric_MyAllergies.27cf3e2c.png";